<template>
  <div class="dialog-box dialog-primary" ref="dialogRef">
    <div class="dialog-header" @mousedown="handleDragStart">
      <span title="查看/设置缩略图">查看/设置缩略图</span>
      <span class="icon" @click="closeDialog">
        <i class="el-icon-close"></i>
      </span>
    </div>
    <div class="dialog-content">
      <div class="thumbnail-box">
        <img v-if="imgSrc" :src="imgSrc" />
        <div class="tip-box" v-else>
          <div class="text-box public-tips-primary">暂无缩略图，点击下方按钮生成缩略图</div>
        </div>
      </div>
    </div>
    <div class="common-button-box dialog-footer">
        <el-button class="primary-btn primary-ang-btn" type="primary" size="small" @click="updateThumbnail">
          以当前视角生成缩略图
        </el-button>
      </div>
  </div>
</template>

<script>
import {
  getBimNodeList,
  getRsNodeList,
  getWmtsNodeList,
  getOsgbNodeList,
  getPointCloudNodeList,
  getCadNodeList,
  getVectorNodeListService,
  updateBimThumbnailService,
  updateRsThumbnailService,
  updateWmtsThumbnailService,
  updateOsgbThumbnailService,
  updatePointCloudThumbnailService,
  updateCadThumbnailService,
  updateVectorThumbnailService,
} from "@/service/interface";

export default {
  data() {
    return { imgSrc: "" };
  },
  props: { visible: Boolean, closeDialog: Function },
  mounted() {
    this.initThumbnail();

    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("mouseup", this.onMouseUp);
  },
  beforeDestroy() {
    document.removeEventListener("mousemove", this.onMouseMove);
    document.removeEventListener("mouseup", this.onMouseUp);
  },
  methods: {
    cancel() {
      this.closeDialog();
    },
    initThumbnail() {
      this.getThumbnail().then((imgSrc) => {
        if (imgSrc) {
          let timestamp = new Date().getTime();
          this.imgSrc = `${window.imageBaseUrl}/${imgSrc}?timestamp=${timestamp}`;
        }
      });
    },
    getThumbnail() {
      return new Promise((resolve) => {
        let { dataType, datasetId } = this.$route.query;
        let params = { dataSetId: datasetId };
        switch (dataType) {
          case "Bim": {
            let nodeId = sessionStorage.getItem("BimNodeId");
            params.nodeId = nodeId;
            getBimNodeList(params).then((response) => {
              if (response.isSuccess) {
                let data = response.data;
                let dataInfo = data.items[0];
                if (dataInfo) {
                  resolve(dataInfo.thumbnail);
                } else {
                  resolve(null);
                }
              } else {
                this.$message.error(response.errMsg);
              }
            });
            break;
          }
          case "Rs": {
            let nodeId = sessionStorage.getItem("RsNodeId");
            params.nodeId = nodeId;
            getRsNodeList(params).then((response) => {
              if (response.isSuccess) {
                let data = response.data;
                let dataInfo = data.items[0];
                if (dataInfo) {
                  resolve(dataInfo.thumbnail);
                } else {
                  resolve(null);
                }
              } else {
                this.$message.error(response.errMsg);
              }
            });
            break;
          }
          case "Wmts": {
            let nodeId = sessionStorage.getItem("WmtsNodeId");
            params.nodeId = nodeId;
            getWmtsNodeList(params).then((response) => {
              if (response.isSuccess) {
                let data = response.data;
                let dataInfo = data.items[0];
                if (dataInfo) {
                  resolve(dataInfo.thumbnail);
                } else {
                  resolve(null);
                }
              } else {
                this.$message.error(response.errMsg);
              }
            });
            break;
          }
          case "Osgb": {
            let nodeId = sessionStorage.getItem("OsgbNodeId");
            params.nodeId = nodeId;
            getOsgbNodeList(params).then((response) => {
              if (response.isSuccess) {
                let data = response.data;
                let dataInfo = data.items[0];
                if (dataInfo) {
                  resolve(dataInfo.thumbnail);
                } else {
                  resolve(null);
                }
              } else {
                this.$message.error(response.errMsg);
              }
            });
            break;
          }
          case "PointCloud": {
            let nodeId = sessionStorage.getItem("PointCloudNodeId");
            params.nodeId = nodeId;
            getPointCloudNodeList(params).then((response) => {
              if (response.isSuccess) {
                let data = response.data;
                let dataInfo = data.items[0];
                if (dataInfo) {
                  resolve(dataInfo.thumbnail);
                } else {
                  resolve(null);
                }
              } else {
                this.$message.error(response.errMsg);
              }
            });
            break;
          }
          case "Cad": {
            let nodeId = sessionStorage.getItem("CadNodeId");
            params.nodeId = nodeId;
            getCadNodeList(params).then((response) => {
              if (response.isSuccess) {
                let data = response.data;
                let dataInfo = data.items[0];
                if (dataInfo) {
                  resolve(dataInfo.thumbnail);
                } else {
                  resolve(null);
                }
              } else {
                this.$message.error(response.errMsg);
              }
            });
            break;
          }
          case "Vector": {
            let nodeId = sessionStorage.getItem("VectorNodeId");
            params.nodeId = nodeId;
            getVectorNodeListService(params).then((response) => {
              if (response.isSuccess) {
                let data = response.data;
                let dataInfo = data.items[0];
                if (dataInfo) {
                  resolve(dataInfo.thumbnail);
                } else {
                  resolve(null);
                }
              } else {
                this.$message.error(response.errMsg);
              }
            });
            break;
          }
        }
      });
    },
    async updateThumbnail() {
      const BlackHole3D = window.BlackHole3D;
      BlackHole3D.Graphics.setSysUIPanelVisible(false);

      await this.sleep(100);

      let imgSrc = BlackHole3D.getScreenSnapshot();
      let base64Image = imgSrc.replace("data:image/png;base64,", "");
      let { dataType, datasetId } = this.$route.query;
      let params = { datasetId: datasetId, base64Image };

      switch (dataType) {
        case "Bim":
          updateBimThumbnailService(params).then((response) => {
            if (response.isSuccess) {
              this.imgSrc = imgSrc;
              BlackHole3D.Graphics.setSysUIPanelVisible(true);
              this.$message.success("更改缩略图成功");
            } else {
              this.imgSrc = imgSrc;
              this.$message.error(response.errMsg);
            }
          });
          break;
        case "Rs":
          updateRsThumbnailService(params).then((response) => {
            if (response.isSuccess) {
              this.imgSrc = imgSrc;
              BlackHole3D.Graphics.setSysUIPanelVisible(true);
              this.$message.success("更改缩略图成功");
            } else {
              this.$message.error(response.errMsg);
            }
          });
          break;
        case "Wmts":
          updateWmtsThumbnailService(params).then((response) => {
            if (response.isSuccess) {
              this.imgSrc = imgSrc;
              BlackHole3D.Graphics.setSysUIPanelVisible(true);
              this.$message.success("更改缩略图成功");
            } else {
              this.$message.error(response.errMsg);
            }
          });
          break;
        case "Osgb":
          updateOsgbThumbnailService(params).then((response) => {
            if (response.isSuccess) {
              this.imgSrc = imgSrc;
              BlackHole3D.Graphics.setSysUIPanelVisible(true);
              this.$message.success("更改缩略图成功");
            } else {
              this.$message.error(response.errMsg);
            }
          });
          break;
        case "PointCloud":
          updatePointCloudThumbnailService(params).then((response) => {
            if (response.isSuccess) {
              this.imgSrc = imgSrc;
              BlackHole3D.Graphics.setSysUIPanelVisible(true);
              this.$message.success("更改缩略图成功");
            } else {
              this.$message.error(response.errMsg);
            }
          });
          break;
        case "Cad":
          updateCadThumbnailService(params).then((response) => {
            if (response.isSuccess) {
              this.imgSrc = imgSrc;
              BlackHole3D.Graphics.setSysUIPanelVisible(true);
              this.$message.success("更改缩略图成功");
            } else {
              this.$message.error(response.errMsg);
            }
          });
          break;
        case "Vector":
          updateVectorThumbnailService(params).then((response) => {
            if (response.isSuccess) {
              this.imgSrc = imgSrc;
              BlackHole3D.Graphics.setSysUIPanelVisible(true);
              this.$message.success("更改缩略图成功");
            } else {
              this.$message.error(response.errMsg);
            }
          });
          break;
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    handleDragStart(e) {
      e.target.style.cursor = "move";
      this.originTop = e.target.offsetParent.offsetTop;
      this.originLeft = e.target.offsetParent.offsetLeft;
      this.originX = e.clientX;
      this.originY = e.clientY;
      this.isMouseDown = true;
    },
    onMouseMove(event) {
      if (!this.isMouseDown) return false;
      let deltaX = event.clientX - this.originX;
      let deltaY = event.clientY - this.originY;
      let activeElement = document.activeElement;
      let maxLeft =
        activeElement.offsetWidth - this.$refs.dialogRef.offsetWidth;
      let maxTop =
        activeElement.offsetHeight - this.$refs.dialogRef.offsetHeight;
      let top = deltaY + this.originTop;
      let left = deltaX + this.originLeft;
      if (left > maxLeft) return false;
      if (top > maxTop) return false;
      if (top <= 0) return false;
      if (left <= 0) return false;

      let dialogRef = this.$refs.dialogRef;
      dialogRef.style.top = `${top}px`;
      dialogRef.style.left = `${left}px`;
    },
    onMouseUp(e) {
      if (!this.isMouseDown) return false;
      this.isMouseDown = false;
      e.target.style.cursor = "default";
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.thumbnail-box {
  display: flex;
  width: 224px;
  height: 144px;
  margin: auto;
  padding: 8px;
  background-color: var(--bimview-thumbnail-bg-color);
  border-radius: 8px;
  border: 1px solid var(--bimview-thumbnail-border-color);

  .tip-box {
    display: flex;
    border: 1px dashed var(--bimview-thumbnail-tip-border-color);

    .text-box {
      margin: auto 10px;
      // color: #aaaaaa;
      // font-size: 14px;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.common-button-box {
  text-align: center;
  justify-content: center;
}

.dialog-box {
  position: absolute;
  top: calc(50% - 150px);
  left: calc(50% - 160px);
  width: 320px;
  text-align: left;
  z-index: 3;
  border-radius: 16px;
  background: var(--dialog-bgColor);

  .dialog-header {
    display: flex;
    justify-content: space-between;
    height: 40px;
    padding: 10px 20px;
    color: var(--dialog-header-icon-color);
    background: var(--dialog-header-bg-color);

    .icon {
      display: flex;
      margin: auto 0px;
      color: var(--dialog-header-icon-color);
      cursor: pointer;

      &:hover {
        background: var(--dialog-header-icon-bgColor);
      }
    }
  }

  .dialog-content {
    padding: 15px 20px;
  }

  .dialog-footer{
    border-top: 1px solid ;
    border-top-color: var(--dialog-footer-border-color) !important;
  }
}
</style>